import axios from 'axios';
export const fetchUserRoleCode = async (roleId) => {
  try {
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const response = await axios.get(`/rolePermission/roleId/${roleId}`, { headers });
    const permissions = response.data.codes;
    localStorage.setItem("permissions", JSON.stringify(permissions));
    return permissions;
  } catch (error) {
    console.error("Error fetching user permissions:", error);
    return [];
  }
};
